
<template>
<div id="app" >
  <!-- <v-app style="background: #003333;"> -->
    <div class="breadcrumbs" id="breadcrumbs" style="pointer-events: none; cursor:default;">
        <div class="breadcrumb-home breadcrumb-btn" style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3); ">
            <img v-bind:src="require(`@/assets/ui/icon_breadcrumb_home.png`)" id="home-icon">
            <p>Timeline Home</p>
        </div>
        <button class="breadcrumb-current breadcrumb-btn">
            <p style="color: black"><span>Primary Source</span></p>
        </button>

        
    </div>
    <button class="breadcrumb-home breadcrumb-btn" style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);" @click="$store.state.showTimeline = true; $store.state.showPrimarySource = false" aria-label="Go to main timeline">
            <p style=""><i class="arrow left" style="width:0.8rem;height:0.8rem"></i></p>
            <p>Back</p>
        </button>

    <div class="source-title-container">
        <h4 id="source-title" style="text-align: center;font-size:2rem;margin:2% 20vw" v-html="source"></h4>
    </div>
    <div class="document-container">
        <div id="block" v-show="!displayOverlay"></div>
        <div class="scroll-content custom-scrollbar" id="style-1">
        <div v-if="primaryIsVideo()" style="padding:0 5%;text-align: center;margin:3% auto; position: relative; width:85%; max-width: 1000px;height:500px" >
            <div style="width:100%;height:100%" v-html="link"></div>
            <ExpandableBox :title="'Video Transcript'" :description="sourceTranscript"></ExpandableBox>
        </div>
        <div v-if="!primaryIsVideo()" class="image-container">
            <img id="source-img" v-bind:src="require(`@/assets/art/primary-source-photos/${ getFileName() }.jpg`)" v-bind:alt="`${source}`" style="max-width: 90%; max-height: 800px; height: auto; width: auto;">
            <form style="text-align: center;" target="_blank">
              <button v-if="link" class="outlined-button" id="original-source-button" v-bind:formaction="link">View Original Source</button>
            </form>
        </div>

        <div id="overlay-rect"></div>
        <div id="overlay">
            <div id="text"></div>
        </div>
        </div>
        <div style="text-align: center">
            <button id="source-button" v-if="isDocument()" @click="toggleRead()"> {{ buttonLabel }} </button>
        </div>
    </div>   
  <!-- </v-app> -->
</div>
</template>

<script>
    import psData from '@/content/primarySources.js'
    import ExpandableBox from './ExpandableBox.vue';
    export default {
    name: 'PrimarySource',

    props: ['source', 'link', 'id'],

    created () {
        window.addEventListener('resize', this.positionElements);
    },

    components:{ExpandableBox},

    methods: {
        getFileName(){
            let file = this.json.find(item => item.id === this.id);
            if(typeof file !== 'undefined') return file.image;
            else return 'placeholder';
        },
        isDocument() {
            let file = this.json.find(item => item.id === this.id);
            if(typeof file !== 'undefined')
            {
                if(typeof file.text !== 'undefined') return true;
                else return false;
            }
            else {
                return false;
            }
            
        },
        primaryIsVideo() {
            if(!this.link){
                return false
            }
            var firstSeven = this.link.slice(0,7);
            return firstSeven == "<iframe";
        },
        toggleRead() {
            if(!this.displayOverlay) {
                document.getElementById("overlay").style.display = "none";
                document.getElementById("source-button").innerText = 'Read';
            }
            else {
                document.getElementById("overlay").style.display = "block";
                document.getElementById("source-button").innerText = 'Back';
            }
            this.displayOverlay = !this.displayOverlay;
            this.positionElements();
        },
        addLineSpacing(str){
            return str.replaceAll(('\n'), ('<br><br>'));
        },
        positionElements(){
            if(this.primaryIsVideo()) return;

            var img = document.getElementById('source-img');
            var breadcrumbs = document.getElementById('breadcrumbs');
            var title = document.getElementById('source-title'); 
            var block = document.getElementById("block");
            var overlay = document.getElementById("overlay");
            var overlayRect = document.getElementById("overlay-rect");
            var text = document.getElementById("text");

            // var screenWidth = document.documentElement.clientWidth;
            // var screenHeight = document.documentElement.clientHeight;
            var left = img.offsetLeft;
            var width = img.clientWidth;
            var bcHeight = breadcrumbs.clientHeight + title.clientHeight;
            var blockTop = bcHeight + overlayRect.clientHeight;
            // var btnHeight = blockTop;

            overlay.style.top = bcHeight + "px";
            block.style.top = blockTop + "px";
            text.style.width = width + "px";
            overlay.style.left = left + "px";

            if(this.isDocument())
            {
                var readBtn = document.getElementById('source-button'); 
                readBtn.style.top = blockTop + "px";
            }
        },
        getText() {
            this.sourceData = this.json.find(item => item.id === this.id);
            this.sourceText = this.addLineSpacing(this.sourceData.text);
            document.getElementById('text').innerHTML="<p>" + this.sourceText + "</p>";
        },
        getTranscript() {
            this.sourceData = this.json.find(item => item.id === this.id);
            this.sourceTranscript = this.sourceData.transcript;

        }
    },

    mounted: function () {
        window.scrollTo(0,0);
        if(this.isDocument()) this.getText();
        if(this.primaryIsVideo) this.getTranscript();
        this.positionElements();
    },  

    data() {
        return {
            json: psData.sources,
            sourceData: {},
            sourceText: '',
            sourceTranscript:'',
            buttonLabel: 'Read',
            displayOverlay: true,
            sourceWidth: 0,
        }
    }
}
</script>

<style lang="css">
</style>